import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate,useLocation } from "react-router-dom";
import { useDisconnect, useAccount } from "wagmi";
import toast from "react-hot-toast";

export default function SubFooter() {
  const navigate = useNavigate();
  const location = useLocation()
    const { address, isConnected } = useAccount();

  const sendToPresaleForm = () => {
        if (!isConnected) {
          toast.error("Please connect your wallet");
          return;
        }
    navigate(`${config.baseUrl}presaleForm`);
    window.scrollTo(0, 0);
  };

  const sendToSwapForm = () => {
        if (!isConnected) {
          toast.error("Please connect your wallet");
          return;
        }
    navigate(`${config.baseUrl}multichainSwapForm`);
    window.scrollTo(0, 0);
  };

  const sendToHowItWorks = () => {
    navigate(`${config.baseUrl}howitwork`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="Security position-relative pt-0 pb-0">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center py-2">
            <Col lg={12} className="pb-5 security-card">
              <div className="bookshap">
                <img src="images/book.png" alt="" />
              </div>
              <Card className="bg-transparent border border-dark p-5">
                <Row className="justify-content-center">
                  <Col xl={12} lg={10}>
                    <div className="security-detail p-md-5 pt-5">
                      <h2 className="text-white mb-4 text-center">
                        Leveraging the{" "}
                        <span className="text-primary-gradient">
                          ©SbSe Protocol,
                        </span>{" "}
                        INFI establishes a transparent, decentralised and
                        community-driven financial infrastructure, setting a new
                        standard for innovation in the blockchain space.
                      </h2>
                    </div>
                    <div className="buyInfi">
                      <Button
                        variant="default"
                        className="btn-white-gradient fw-bold text-black px-4 rounded-5 position-relative z-2 me-sm-3"
                        onClick={sendToPresaleForm}
                      >
                        RAISE A FUND&nbsp;&nbsp;&nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="16"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                      <Button
                        className="px-4 rounded-5 bg-black  position-relative z-2 me-sm-3 border"
                        onClick={sendToSwapForm}
                        disabled
                      >
                        List Your Project&nbsp;&nbsp;&nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="16"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                      {location.pathname !== `${config.baseUrl}howitwork` && (
                      <Button
                        variant="custombtn"
                        className="text-black px-4 rounded-5 position-relative z-2 text-uppercase"
                        onClick={sendToHowItWorks}
                      >
                        How it Works&nbsp;&nbsp;&nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="16"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>)}
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
        <div className="bg-shape3 ">
          <img src="images/bg-shape3.png" alt="" />
        </div>
      </section>
    </>
  );
}
